module.exports = __webpack_public_path__ + "img/IMG-20191005-WA0009.e278371c.jpg";